export default __webpack_public_path__ + "static/media/react-admin-dashboard.65e9e33d.png";